import { render, staticRenderFns } from "./mBusiness.vue?vue&type=template&id=8b7de922&scoped=true"
import script from "./mBusiness.vue?vue&type=script&lang=js"
export * from "./mBusiness.vue?vue&type=script&lang=js"
import style0 from "./mBusiness.vue?vue&type=style&index=0&id=8b7de922&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7de922",
  null
  
)

export default component.exports